/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Vu Dinh Luan (vdluan@rsupport.com)
 *
 * @description
 *
 * @created at Thu Dec 19 2024
 **/
import styled from "@emotion/styled";

import { Avatar, Button, Column, Divider, Row, Typography, TypographyCSS } from "@/frameworks/designStuff/components";
import { useSpace } from "@/frameworks/core/API";
import { useUnitySystemActions } from "@/frameworks/core/unity";
import { _T } from "@rfice/language";

import * as S from "../private/emotion";

export default function SpaceJoined({
	spaceInfo,
	onClose
}: {
	spaceInfo: PushServices.Space.SpaceJoined.Data["spaceInfo"];
	onClose: () => void;
}) {
	const spaceAPI = useSpace();
	const unitySystemActions = useUnitySystemActions();

	const handleEnter = async () => {
		const { data: spaceData } = await spaceAPI.detail.execute({ spaceId: spaceInfo.id });
		if (spaceData) {
			unitySystemActions.go("userGuesture", {
				spaceType: "SPACE",
				spaceId: spaceData.spaceId || "",
				spaceScene: spaceData?.spaceScene
			});
		}
	};

	return (
		<S.NoticeWrapperGroupJoin gap={12}>
			<Row css={{ position: "absolute", right: "20px", top: "8px" }}>
				<Button.Icon name="Close24" filled="transparent" variant="contained" size="medium" onClick={onClose} />
			</Row>
			<Row gap={16}>
				<Avatar
					kind="space_80"
					type="image"
					text={spaceInfo.name ?? ""}
					textColor="deco1_50_100"
					src={spaceInfo.thumbnailPath}
					css={{
						flex: "none"
					}}
				/>
				<Column gap={8}>
					<Typography typoSize="Head6">{spaceInfo.name}</Typography>
					<Column>
						<UserName typoSize="Body3_MD">{_T("스페이스 가입 완료되었습니다.")}</UserName>
					</Column>
				</Column>
			</Row>
			<Divider type="line" />
			<Row style={{ width: "100%" }} horizonAlign="right" gap={8}>
				<Button filled="primary" onClick={handleEnter}>
					{_T("입장하기")}
				</Button>
			</Row>
		</S.NoticeWrapperGroupJoin>
	);
}

const UserName = styled(Typography)`
	#target {
		${TypographyCSS("Title3")}
	}
	white-space: pre-wrap;
`;
